"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AllUserOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AllUserOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2.25c0 .423-.117.819-.32 1.157-.477.233-.895.57-1.224.98A2.25 2.25 0 1 1 6.75 2.25Zm-1 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM9.57 3.408c.477.233.894.569 1.223.979a2.25 2.25 0 1 0-1.223-.979Zm1.93.092a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.519 5.786H4.5c-2.7 0-4.5 1.209-4.5 2.7a1.8 1.8 0 0 0 1.8 1.8h3.104a8.385 8.385 0 0 1 1.635-.392 3.583 3.583 0 0 1-.934-.608H1.8a.8.8 0 0 1-.8-.8c0-.299.174-.693.765-1.06.58-.36 1.483-.629 2.658-.64a3.647 3.647 0 0 1 .096-1ZM14.2 10.286h-3.105a8.384 8.384 0 0 0-1.635-.392c.343-.154.658-.36.934-.608H14.2a.8.8 0 0 0 .8-.8c0-.299-.174-.693-.765-1.06-.58-.36-1.483-.629-2.66-.64a3.586 3.586 0 0 0-.095-1h.02c2.7 0 4.5 1.209 4.5 2.7a1.8 1.8 0 0 1-1.8 1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.25A2.625 2.625 0 1 0 8 4a2.625 2.625 0 0 0 0 5.25Zm0-1A1.625 1.625 0 1 0 8 5a1.625 1.625 0 0 0 0 3.25ZM8 10.75c-3.15 0-5.25 1.41-5.25 3.15 0 1.16.94 2.1 2.1 2.1h6.3a2.1 2.1 0 0 0 2.1-2.1c0-1.74-2.1-3.15-5.25-3.15Zm-3.279 1.772c-.722.448-.971.955-.971 1.378a1.1 1.1 0 0 0 1.1 1.1h6.3a1.1 1.1 0 0 0 1.1-1.1c0-.423-.249-.93-.971-1.378-.723-.448-1.841-.772-3.279-.772s-2.556.324-3.279.772Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AllUserOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AllUserOutline;
exports["default"] = _default;